/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BedOccupancyStatsResponse } from './BedOccupancyStatsResponse';
import {
    BedOccupancyStatsResponseFromJSON,
    BedOccupancyStatsResponseFromJSONTyped,
    BedOccupancyStatsResponseToJSON,
    BedOccupancyStatsResponseToJSONTyped,
} from './BedOccupancyStatsResponse';

/**
 * 
 * @export
 * @interface GetFacilityBedOccupancyStats200Response
 */
export interface GetFacilityBedOccupancyStats200Response {
    /**
     * 
     */
    data?: BedOccupancyStatsResponse;
}

/**
 * Check if a given object implements the GetFacilityBedOccupancyStats200Response interface.
 */
export function instanceOfGetFacilityBedOccupancyStats200Response(value: object): value is GetFacilityBedOccupancyStats200Response {
    return true;
}

export function GetFacilityBedOccupancyStats200ResponseFromJSON(json: any): GetFacilityBedOccupancyStats200Response {
    return GetFacilityBedOccupancyStats200ResponseFromJSONTyped(json, false);
}

export function GetFacilityBedOccupancyStats200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacilityBedOccupancyStats200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : BedOccupancyStatsResponseFromJSON(json['data']),
    };
}

export function GetFacilityBedOccupancyStats200ResponseToJSON(json: any): GetFacilityBedOccupancyStats200Response {
    return GetFacilityBedOccupancyStats200ResponseToJSONTyped(json, false);
}

export function GetFacilityBedOccupancyStats200ResponseToJSONTyped(value?: GetFacilityBedOccupancyStats200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BedOccupancyStatsResponseToJSON(value['data']),
    };
}

